import { type FC } from 'react';
import { Help, type HelpProps, Link } from '@direct-frontend/components';
import { LINK_AUTOMATIC_COLLECTIONS_INSTRUCTION } from '../../lib/constants';

export const AutomaticCollectionsHelp: FC<HelpProps> = (props) => (
    <Help {...props} maxWidth="360">
        Сформированы автоматически по предзаданным параметрам. Подробнее можно прочитать в{' '}
        <Link href={LINK_AUTOMATIC_COLLECTIONS_INSTRUCTION} target="_blank" rel="noreferrer">
            справке
        </Link>
    </Help>
);
